import React from 'react';
import {
  Header,
  SpaceBetween,
  Box,
  Button,
  Badge,
} from "@cloudscape-design/components";
import { parseCustomerExperience } from '../../../utils/insights/contactSummaryParser';

export default function InfoTab({
  selectedCall,
  callDetails,
  history,
  t,
  onClosePanel
}) {
  // Parsear CustomerExperience si hay datos
  const parsedData = callDetails?.ConversationAnalytics?.CustomerExperience
    ? parseCustomerExperience(callDetails.ConversationAnalytics.CustomerExperience)
    : null;

  const feedbackCX = parsedData?.feedbackCX || {};
  const satisfaccion = feedbackCX.satisfaccion;
  const emociones = feedbackCX.emociones || [];
  const frasesClave = feedbackCX.frasesClave || [];

  // Usar solo la key que devuelve el backend (igual que Lista de llamadas)
  const s3Key = selectedCall?.key;

  return (
    <div style={{ width: '100%', minWidth: '350px' }}>
      <SpaceBetween size="l">
      {/* Sección A: Información de la llamada */}
      <div>
        <Header variant="h3" margin={{ bottom: "m" }}>
          {t("insights.callInformation", { defaultValue: "Información de la llamada" })}
        </Header>
        <SpaceBetween size="m">
          <div>
            <Box variant="awsui-key-label" margin={{ bottom: "xxs" }}>
              {t("insights.name", { defaultValue: "Nombre" })}
            </Box>
            <Box 
              style={{ 
                overflow: 'hidden', 
                textOverflow: 'ellipsis', 
                whiteSpace: 'nowrap'
              }}
              title={selectedCall?.jobName || "-"}
            >
              {selectedCall?.jobName || "-"}
            </Box>
          </div>
          {s3Key && (
            <Button
              variant="normal"
              iconAlign="right"
              iconName="external"
              onClick={() => {
                if (onClosePanel) {
                  onClosePanel();
                }
                history.push(`/dashboard/${s3Key}`);
              }}
            >
              {t("insights.viewFullDetail", { defaultValue: "Ver detalle completo" })}
            </Button>
          )}
        </SpaceBetween>
      </div>

      {/* Línea divisoria */}
      <div style={{ 
        borderTop: '1px solid var(--color-border-divider-default, #d1d5db)',
        margin: '16px 0'
      }} />

      {/* Sección B: Feedback CX */}
      <div>
        <Header variant="h3" margin={{ bottom: "m" }}>
          {t("insights.feedbackCX", { defaultValue: "Feedback CX" })}
        </Header>
        <Box color="text-body-secondary" variant="p" margin={{ bottom: "m" }}>
          {t("insights.feedbackCXDescription", { defaultValue: "Análisis del tono, las emociones y las expresiones detectadas en la conversación para evaluar la percepción del cliente." })}
        </Box>
        <SpaceBetween size="m">
          {/* Satisfacción - DOS badges según datos reales */}
          <div>
            <Box variant="awsui-key-label" margin={{ bottom: "xs" }}>
              {t("insights.satisfaction", { defaultValue: "Satisfacción" })}
            </Box>
            {satisfaccion ? (
              <Badge color={
                satisfaccion === "Positivo" ? "green" :
                satisfaccion === "Negativo" ? "red" : "grey"
              }>
                {satisfaccion}
              </Badge>
            ) : (
              <Box color="text-body-secondary" variant="p">
                {t("insights.noSatisfactionData", { defaultValue: "No hay datos de satisfacción disponibles" })}
              </Box>
            )}
          </div>

          {/* Emociones - múltiples badges en wrap */}
          <div>
            <Box variant="awsui-key-label" margin={{ bottom: "xs" }}>
              {t("insights.emotions", { defaultValue: "Emociones" })}
            </Box>
            {emociones.length > 0 ? (
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                {emociones.map((emotion, index) => (
                  <Badge key={index} color="blue">{emotion}</Badge>
                ))}
              </div>
            ) : (
              <Box color="text-body-secondary" variant="p">
                {t("insights.noEmotions", { defaultValue: "No se detectaron emociones en esta llamada" })}
              </Box>
            )}
          </div>

          {/* Frases clave - lista con comillas */}
          <div>
            <Box variant="awsui-key-label" margin={{ bottom: "xs" }}>
              {t("insights.keyPhrases", { defaultValue: "Frases clave" })}
            </Box>
            {frasesClave.length > 0 ? (
              <SpaceBetween size="xs">
                {frasesClave.map((phrase, index) => (
                  <Box key={index} color="text-body-secondary" style={{ fontStyle: 'italic' }}>
                    "{phrase}"
                  </Box>
                ))}
              </SpaceBetween>
            ) : (
              <Box color="text-body-secondary" variant="p">
                {t("insights.noKeyPhrases", { defaultValue: "No se encontraron frases clave en esta llamada" })}
              </Box>
            )}
          </div>
        </SpaceBetween>
      </div>
    </SpaceBetween>
    </div>
  );
}
